import React from "react";
// import video from '../img/Video2.mp4'
import carosel1 from '../img/carosel/Image.jpg';
import carosel2 from '../img/carosel/Image1.jpg';
import carosel3 from '../img/carosel/Image2.jpg';
import Carousel from 'react-bootstrap/Carousel';

const CaraselImg = () => {
  return (
    <>
        {/* <video playsInline="playsinline" autoPlay="autoplay" muted="muted" loop="loop" style={{width: '100%'}}>
          <source src={video} type="video/mp4"/>
        </video> */}
        <Carousel slide={false} interval={5000} style={{zIndex:'0'}} className="overlay" >
            <Carousel.Item>
            <img src={carosel1} className="w-100" alt="" />
            </Carousel.Item>
            <Carousel.Item>
                <img src={carosel2} className="w-100" alt="" />
            </Carousel.Item>
            <Carousel.Item>
                <img src={carosel3} className="w-100" alt="" />
            </Carousel.Item>
        </Carousel>
    </>
  );
}

export default CaraselImg;